import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useMemo, useRef } from "react";
import { makeStyles } from "tss-react/mui";
import HorizontalSelector from "../../../../../common/inputs/HorizontalSelector";
import { TaskEnums } from "../../../../../../common/constants";
import { CheckCircleOutline as CheckCircleIcon, Close as CloseIcon } from "@mui/icons-material";
import DateAndTimePicker from "../../../../../common/inputs/DateAndTimePicker";
import PlanningQuickSelect from "./PlanningQuickSelect";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      position: "relative",
      width: "100%"
    },
    stack: {
      position: "relative",
      width: "100%",
      height: "auto"
    }
  })
);


export default function PlanningPanel(props) {
  const { plannedType, plannedStart, plannedEnd, onClose } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();
  const quickSelectFunctions = useRef();

  const selectorItems = useMemo(() => [
    t("task:enums:plannedType:None"),
    t("task:enums:plannedType:Time"),
    t("task:enums:plannedType:Interval"),
  ], [t]);

  const onSelectorChange = useCallback((value) => {

    switch (value) {
      case TaskEnums.PlanningType.None:
        plannedStart.onChange(null, null);
        plannedEnd.onChange(null, null);
        break;
      case TaskEnums.PlanningType.Interval:

        break;
      case TaskEnums.PlanningType.Time:
        plannedStart.onChange(null, null);
        break;
    }

    plannedType.onChange(null, value);

  }, [plannedType.onChange, plannedStart.onChange, plannedEnd.onChange]);

  return (
    <Box className={classes.root}>
      <Stack spacing={1}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="subtitle2" fontWeight={500}>{t("mission:cards:tasks:planning:panel:title")}</Typography>
          <IconButton size="small" onClick={onClose} color="primary">
            <CloseIcon />
          </IconButton>
        </Stack>

        <HorizontalSelector items={selectorItems} value={plannedType.value} onChange={onSelectorChange} disabled={false} />

        {
          plannedType.value === TaskEnums.PlanningType.Interval ? (
            <Stack spacing={1}>

              <Typography variant="caption" color="textSecondary">{t("mission:cards:tasks:planning:panel:quickSelect")}</Typography>

              <PlanningQuickSelect
                plannedStart={plannedStart}
                plannedEnd={plannedEnd}
                functionsRef={quickSelectFunctions}
              />

              <Typography variant="caption" color="textSecondary">{t("mission:cards:tasks:planning:panel:interval")}</Typography>

              <DateAndTimePicker
                onFocus={() => quickSelectFunctions?.current?.reset()}
                disabled={false}
                label={t("mission:cards:tasks:planning:panel:timeStart")}
                value={plannedStart.value}
                onChange={plannedStart.onChange}
                includeTime
                fromNow
              />

              <DateAndTimePicker
                onFocus={() => quickSelectFunctions?.current?.reset()}
                disabled={false}
                label={t("mission:cards:tasks:planning:panel:timeEnd")}
                value={plannedEnd.value}
                onChange={plannedEnd.onChange}
                includeTime
                fromNow
              />

            </Stack>
          ) : plannedType.value === TaskEnums.PlanningType.Time ? (
            <Stack>
              <DateAndTimePicker
                disabled={false}
                label={t("mission:cards:tasks:planning:panel:time")}
                value={plannedEnd.value}
                onChange={plannedEnd.onChange}
                includeTime
                fromNow
              />

            </Stack>
          ) : (
            <Stack justifyContent="center" alignItems="center" sx={{ p: 1.5 }} spacing={0.5}>
              <CheckCircleIcon sx={{ color: "text.secondary" }} />
              <Typography variant="body2" color="textSecondary">{t("mission:cards:tasks:planning:panel:defaultDescription")}</Typography>
            </Stack>
          )
        }

      </Stack>
    </Box>
  );
}

